import { useContext, useEffect, useState } from "react";

import Axios from "axios";
import { Col, Table } from "react-bootstrap";
import DashboardContext from "../../../../Context";

const WalletTabelWrker = ({ id }) => {

    //console.log(id);

    const { authentication, urldashboard, handelerrors, walletupdate } = useContext(DashboardContext)

    const [data, setData] = useState({});

    const dataFeching = async () => {
        try {
            const res = await Axios.get(`${urldashboard}/worker/get/${id}`, {
                headers: {
                    "Authorization": authentication,
                    "Content-Type": "application/json"
                }
            })
            const datas = await res.data.data

            setData(datas)
        } catch (error) {
            handelerrors(error)
        }
        
    }


    useEffect(() => {
        dataFeching();
        return () => {

        }
    }, [walletupdate])

    return (
        <Col md='12' lg='12' sm='12' >
            <Table bordered hover >
                <tbody>
                    <tr>
                        <td className='text-nowrap' >شماره شبا </td>
                        <td >IR-{data.shebaCode}</td>
                    </tr>
                    <tr>
                        <td className='text-nowrap' >شماره کارت <i className="mdi mdi-credit-card"></i></td>
                        <td  >{data.debitCardNumber} </td>
                    </tr>
                    <tr>
                        <td className='text-nowrap' >اعتبار کیف پول<i className=" mr-1 mdi mdi-wallet"></i></td>
                        <td  >{new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 12 }).format(data.walletAmount)} <small>ريال</small></td>
                    </tr>
                    <tr>
                        <td className='text-nowrap' >مبلغ بدهی<i className=" mr-1 mdi mdi-database-minus"></i></td>
                        <td  >{new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 12 }).format(data.debtAmount)} <small>ريال</small></td>
                    </tr>
                    <tr>
                        <td className='text-nowrap' >مانده بدهی خوابگاه<i className=" mr-1 mdi mdi-database-minus"></i></td>
                        <td  >{new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 12 }).format(data.dormDebt)} <small>ريال</small></td>
                    </tr>
                    <tr>
                        <td className='text-nowrap' >مابه التفاوت حساب<i className=" mr-1 mdi mdi-database"></i></td>
                        <td  >{new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 12 }).format(data.differenceAmount)} <small>ريال</small></td>
                    </tr>
                </tbody>
            </Table>
        </Col>
    );
}

export default WalletTabelWrker;
